import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Layout, Tabs, Button, Space } from 'antd';
import { EditFilled, DollarOutlined } from '@ant-design/icons';
import { get } from '../redux/actions/campanaActions';
import CampanaEditor from './CampanaEditor';
import ActividadList from './ActividadList';
import AlquilerList from './AlquilerList';
import CampanaResumenProduccion from './CampanaResumenProduccion';
import CampanaResumenInversion from './CampanaResumenInversion';
import { callStatus } from '../utils/constants';
import { withRouter } from 'react-router-dom';
import { setBreadcrumbTitle } from '../redux/actions/uiActions';
import GananciaEditor from './GananciaEditor';
import { setPending as setPendingGanancia } from '../redux/actions/gananciaActions';

const { Content } = Layout;
const { TabPane } = Tabs;

const CampanaViewer = ({
  dispatch,
  stateData,
  match: {
    params: { id },
  },
  location,
  history,
}) => {
  const [showEdit, setShowEdit] = useState(false);
  const [showGanancia, setShowGanancia] = useState(false);

  const handleHideEditor = () => {
    setShowEdit(false);
  };

  const handleHideGananciaEditor = () => {
    setShowGanancia(false);
    dispatch(setPendingGanancia());
  };

  useEffect(() => {
    if (String(stateData.object.data?.id) !== String(id)) {
      dispatch(get(id));
    }
    // eslint-disable-next-line
  }, [id, dispatch]);

  useEffect(() => {
    if (
      stateData.object.status === callStatus.OBJECT_SUCCESS ||
      stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS
    ) {
      dispatch(
        setBreadcrumbTitle(`/campanas/${id}`, stateData.object.data.nombre)
      );
    }
  }, [stateData.object.status, stateData.object.data, dispatch, id]);

  const getActiveKey = () => {
    if (location.pathname.includes('/alquileres')) return '2';
    if (location.pathname.includes('/produccion')) return '3';
    if (location.pathname.includes('/inversion')) return '4';
    return '1';
  };

  const handleTabChange = (key) => {
    let path = `/campanas/${id}`;
    if (key === '1') path += '/actividades';
    if (key === '2') path += '/alquileres';
    if (key === '3') path += '/produccion';
    if (key === '4') path += '/inversion';
    history.replace(path);
  };

  return (
    <Layout style={{ height: '100%' }}>
      <Content>
        <Tabs
          activeKey={getActiveKey()}
          onChange={handleTabChange}
          destroyInactiveTabPane
          tabBarExtraContent={
            <Space>
              <Button
                icon={<EditFilled />}
                onClick={() => setShowEdit(true)}
                type="primary"
                size="small"
              >
                Editar Campaña
              </Button>
              <Button
                icon={<DollarOutlined />}
                onClick={() => setShowGanancia(true)}
                type="primary"
                size="small"
              >
                Total Gastos Ganancia
              </Button>
            </Space>
          }
        >
          <TabPane tab="Actividades" key="1">
            <div style={{ height: 'calc(100vh - 200px)' }}>
              <ActividadList campanaId={id} />
            </div>
          </TabPane>
          <TabPane tab="Alquileres" key="2">
            <div style={{ height: 'calc(100vh - 200px)' }}>
              <AlquilerList campanaId={id} />
            </div>
          </TabPane>
          <TabPane tab="Producción" key="3">
            <div style={{ height: 'calc(100vh - 200px)' }}>
              <CampanaResumenProduccion campanaId={id} />
            </div>
          </TabPane>
          <TabPane tab="Inversión" key="4">
            <div style={{ height: 'calc(100vh - 200px)' }}>
              <CampanaResumenInversion campanaId={id} />
            </div>
          </TabPane>
        </Tabs>
      </Content>
      {showEdit && (
        <CampanaEditor id={id} onCancel={handleHideEditor} visible={true} />
      )}
      {showGanancia && (
        <GananciaEditor
          id={null}
          parentId={id}
          onCancel={handleHideGananciaEditor}
          visible={true}
        />
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  stateData: state.campana,
});

export default connect(mapStateToProps)(withRouter(CampanaViewer));
